import { useState, useCallback, useEffect } from "react";
import {
	TextField,
	InputAdornment,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Checkbox,
	withStyles,
	ListItemIcon,
	ListItem,
	Divider,
	List,
	ListItemText,
	CheckboxProps,
	Breadcrumbs,
	Link
} from "@material-ui/core";
import { TreeViewProps } from "../../../../../../@types/components/assignGroupsProps.types";
import { AnnouncementGroupAndLocations, LocationSchema } from "../../../../../../@types/group.types";
import { green } from "@material-ui/core/colors";

import SearchIcon from "@material-ui/icons/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

import "./treeView.css";
import { useEmployerRoute } from "../../../../../../hooks";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import { useNavigate } from "react-router-dom";

type CheckedLocationsType = {
	[key: string]: boolean; // Keys are strings, and values are booleans
};
type LocationsType = {
	[key: string]: any; // Keys are strings, and values are booleans
};

const TreeView = (props: any) => {
	// console.log("announcementsss");
	const [filteredGroups, setFilteredGroups] = useState<AnnouncementGroupAndLocations[]>([]);
	const {
		// handleAssignGroup,
		handleAssignLocation,
		announcementId,
		// handleSaveAllGroups,
		handleSaveAllLocations,
		// assignmentStatus,
		handleSelectProfile
	} = props;
	const [groups, setGroups] = useState<AnnouncementGroupAndLocations[]>([]);

	const [checkedLocations, setCheckedLocations] = useState<CheckedLocationsType>({});

	const [allLocations, setAllLocations] = useState<LocationsType>({});

	const [selectAllLocations, setSelectAllLocations] = useState(false);

	const handleCheck = (key: string) => {
		// eslint-disable-next-line arrow-parens
		setCheckedLocations((prev) => ({
			...prev,
			[key]: !checkedLocations[key] // Update the specific key-value pair
		}));
	};

	const isEmployerRoute = useEmployerRoute();
	const queryGroupNumber = useRouteParam("gn");
	const navigate = useNavigate();

	const DarkCheckbox = withStyles({
		root: {
			color: "#757575",
			"&$checked": {
				color: "#757575"
			}
		},
		checked: {}
	})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

	const GreenCheckbox = withStyles({
		root: {
			color: green[400],
			"&$checked": {
				color: green[600]
			}
		},
		checked: {}
	})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

	const handleSearchChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target;
			const searchQuery = value.toLowerCase();
			const _filteredGroups: AnnouncementGroupAndLocations[] = [];

			groups.forEach((group: AnnouncementGroupAndLocations) => {
				const { name } = group.group_info as { name: string };
				if (name.toLowerCase().indexOf(searchQuery) !== -1) {
					_filteredGroups.push(group);
				}
			});

			setFilteredGroups(Object.assign([], _filteredGroups));
		},
		[props.groups]
	);

	const handleSelectAllLocations = async () => {
		let checkedLocationsIds = Object.keys(checkedLocations);

		if (selectAllLocations) {
			checkedLocationsIds = checkedLocationsIds.filter((location_number: any) => {
				// console.log("Filter Condition:", location_number, checkedLocations[location_number], selectAllLocations);
				return checkedLocations[location_number] == selectAllLocations;
			});
			// console.log("checkedLocationsIds", checkedLocationsIds, group);
		} else {
			checkedLocationsIds = checkedLocationsIds.filter((location_number: any) => {
				// console.log("Filter Condition:", location_number, checkedLocations[location_number], selectAllLocations);
				return checkedLocations[location_number] == selectAllLocations;
			});
			// console.log("checkedLocationsIds", JSON.stringify(group));
		}

		// console.log("checkedLocationsIds", checkedLocationsIds);

		handleSaveAllLocations(checkedLocationsIds);
	};

	const handleBreadcrumClick = useCallback(() => {
		let pathname;
		if (isEmployerRoute === true && queryGroupNumber !== null) {
			pathname = `/employer/settings/announcements?gn=${queryGroupNumber}`;
		} else {
			pathname = "/settings/announcements";
		}

		navigate(pathname);
	}, [isEmployerRoute, navigate, queryGroupNumber]);

	useEffect(() => {
		// if (isEmployerRoute !== null && queryGroupNumber !== undefined) {
		// 	if (isEmployerRoute === true && queryGroupNumber !== null) {
		const _groups: any[] = [];
		props.groups.forEach((_group: any) => {
			// const { group_number } = _group;
			// if (group_number === Number(queryGroupNumber)) {
			_groups.push(_group);
			// }
		});
		setGroups(Object.assign([], _groups));
		setFilteredGroups(Object.assign([], _groups));
		// 	} else {
		// 		setGroups(Object.assign([], props.groups));
		// 		setFilteredGroups(Object.assign([], props.groups));
		// 	}
		// } else {
		// 	setGroups(Object.assign([], props.groups));
		// 	setFilteredGroups(Object.assign([], props.groups));
		// }
	}, [isEmployerRoute, props.groups, queryGroupNumber]);

	useEffect(() => {
		// console.log("props.groups", props.groups);
		const _groups: LocationsType = {};
		const _checked: CheckedLocationsType = {};
		props.groups.forEach((group: any) => {
			// console.log("groups", group.assigned_locations.location_number);
			group.assigned_locations.forEach((assignLocation: any) => {
				// console.log("assign", assignLocation.location_number);
				_groups[assignLocation.location_number] = assignLocation;
				_checked[assignLocation.location_number] = true;
			});

			group.unassigned_locations.forEach((unassignLocation: any) => {
				// console.log("assign", unassignLocation.location_number);
				_groups[unassignLocation.location_number] = unassignLocation;
				_checked[unassignLocation.location_number] = false;
			});
		});
		setAllLocations(_groups);
		setCheckedLocations(_checked);
		props.groups.forEach((group: any) => {
			if (group.unassigned_locations.length === 0) {
				setSelectAllLocations(true);
			} else {
				setSelectAllLocations(false);
			}
		});
	}, [props.groups]);

	useEffect(() => {
		// eslint-disable-next-line arrow-parens
		const allChecked = Object.values(checkedLocations).every((value) => value === true);

		if (allChecked) {
			setSelectAllLocations(true);
		} else {
			setSelectAllLocations(false);
		}
	}, [Object.values(selectAllLocations)]);

	// console.log("filteredGroups", filteredGroups);

	return (
		<div className="tree-view announcements-tree-view">
			<div className="breadcrum-text-container" id="breadcrum-text">
				<Breadcrumbs
					separator={<NavigateNextIcon fontSize="small" style={{ color: "#e0e0e0" }} />}
					aria-label="breadcrumb"
				>
					<Link className="breadcrumb-link-text" onClick={handleBreadcrumClick}>
						Announcements
					</Link>
					<span className="breadcrumb-text">Assign Locations</span>
				</Breadcrumbs>
			</div>
			<div>
				<TextField
					id="search-groups"
					placeholder="Search Groups"
					variant="outlined"
					fullWidth
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<SearchIcon style={{ color: "#7cb342" }} />
							</InputAdornment>
						)
					}}
					onChange={handleSearchChange}
				/>
			</div>
			{/* {isEmployerRoute === false ? (
				<div className="select-actions-container">
					<div className="flex-item-start">
						<DarkCheckbox onChange={handleSaveAllGroups} checked={assignmentStatus.all_groups} />
						All Groups
						<DarkCheckbox onChange={handleSaveAllLocations} checked={assignmentStatus.all_locations} />
						All Locations
					</div>
				</div>
			) : null} */}
			<Divider className="actions-divider" />
			<div className="items">
				{filteredGroups.length !== 0 ? (
					filteredGroups.map((group: AnnouncementGroupAndLocations) => {
						const { _id, assigned_locations, unassigned_locations } = group;
						const { name } = group.group_info as { name: string };
						return (
							<Accordion key={_id}>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									className="accordion-summary-container"
								>
									<div className="accordion-summary">
										<span
											onClick={(event: React.MouseEvent<HTMLSpanElement>) =>
												event.stopPropagation()
											}
										>
											<GreenCheckbox checked={true} className="select-group-icon" />
										</span>
										<span
											className="group-name"
											onClick={(event: React.MouseEvent<HTMLSpanElement>) => {
												event.stopPropagation();
												handleSelectProfile(group, "group");
											}}
											onFocus={(event: React.FocusEvent<HTMLSpanElement>) =>
												event.stopPropagation()
											}
										>
											{name}
										</span>
									</div>
								</AccordionSummary>
								<AccordionDetails>
									<List className="location-list">
										<ListItem key={_id}>
											<ListItemIcon
												onClick={() => {
													handleSelectAllLocations();
												}}
											>
												<GreenCheckbox
													className="select-group-icon"
													checked={selectAllLocations}
												/>
											</ListItemIcon>
											<ListItemText
												className="list-location-text"
												primary={"Select All Locations"}
												// onClick={() => handleSelectProfile(group, "group")}
											/>
										</ListItem>
										{Object.keys(allLocations).length !== 0 &&
											Object.keys(allLocations).map((location_number: any) => {
												const { _id, location_name } = allLocations[location_number];
												return (
													<ListItem key={_id}>
														<ListItemIcon
															onClick={() => {
																handleAssignLocation(
																	allLocations[location_number],
																	false
																);
																handleCheck(location_number);
															}}
														>
															<GreenCheckbox
																className="select-group-icon"
																checked={checkedLocations[location_number]}
															/>
														</ListItemIcon>
														<ListItemText
															className="list-location-text"
															primary={`${location_number} - ${location_name}`}
															onClick={() => handleSelectProfile(group, "group")}
														/>
													</ListItem>
												);
											})}
										{/* {assigned_locations.length !== 0 &&
											assigned_locations.map((location: LocationSchema) => {
												const { _id, location_name } = location;
												return (
													<ListItem key={_id}>
														<ListItemIcon
															onClick={() => handleAssignLocation(location, false)}
														>
															<GreenCheckbox
																className="select-group-icon"
																checked={true}
															/>
														</ListItemIcon>
														<ListItemText
															className="list-location-text"
															primary={location_name}
															onClick={() => handleSelectProfile(group, "group")}
														/>
													</ListItem>
												);
											})}
										{unassigned_locations.length !== 0 &&
											unassigned_locations.map((location: LocationSchema) => {
												const { _id, location_name } = location;
												return (
													<ListItem key={_id}>
														<ListItemIcon
															onClick={() => handleAssignLocation(location, true)}
														>
															<GreenCheckbox
																className="select-group-icon"
																checked={false}
															/>
														</ListItemIcon>
														<ListItemText
															className="list-location-text"
															primary={location_name}
															onClick={() => handleSelectProfile(group, "group")}
														/>
													</ListItem>
												);
											})} */}
									</List>
								</AccordionDetails>
							</Accordion>
						);
					})
				) : (
					<div className="no-result">No such groups found!</div>
				)}
			</div>
		</div>
	);
};

export default TreeView;
